import { Component, EventEmitter, Input, Output, Inject, OnInit, OnDestroy } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { Subscription, filter } from 'rxjs';

import { InteractionModel } from '../../../../../Discover/Targeting/models/interaction-model';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { TargetingListService } from '../../../../../Discover/Targeting/services/targeting-list.service';
import { TargetingSearchService } from '../../../../../Discover/Targeting/services/targeting-search.service';
import { ListPickerService } from '../../../services/list-picker.service';
import { ResultCardDirective } from '../../../../TargetingShared/components/ResultCard/result-card.directive';
import { TargetingRhpContextsService } from '../../../../TargetingShared/services/targeting-rhp-contexts.service';
import { InteractionType } from '../../../../../api/targeting/enum/interaction-type.enum';
import { topStatLabels } from '../../../../TargetingShared/model/statisticsReport/distribution-report-stat-map.model';
import { ButtonTypesEnum } from '../../../../Forms/enums/button-types.enum';
import { CurrentUserStateService } from '../../../../../Core/Users/services/current-user-state.service';
import { PreferencesModel } from '../../../../../Core/Users/models/preferences.model';
import { DistributionReportStat } from '../../../../TargetingShared/model/statisticsReport/distribution-report-stat-api.model';
import { EmailEventApiModel } from '../../../../../api/distributions/model/email-event.api.model';
import { DistributionPickerService } from '../../../services/distribution-picker.service';

interface EventViewModel {
    heading: string;
    type: DistributionReportStat;
    eventList: EmailEventApiModel[];
    link: string;
}

@Component({
    selector: 'agpr-interaction-card',
    templateUrl: './interaction-card.component.html',
    styleUrls: ['./interaction-card.component.scss', '../../../../TargetingShared/components/ResultCard/result-card.scss'],
    standalone: false
})
export class InteractionCardComponent extends ResultCardDirective implements OnInit, OnDestroy {

    readonly distributionReportStat = DistributionReportStat;

    @Input() set interaction(value: InteractionModel) {
        this.interactionInternal = value;

        value.events?.forEach(event => {
            const parentEvent = this.eventHierarchy.find(x => x.type === event.type);
            if (parentEvent) {
                parentEvent.eventList.push(event);
            } else {
                this.eventHierarchy.push(<EventViewModel>{
                    heading: topStatLabels.get(event.type),
                    type: event.type,
                    eventList: [event],
                    link: event.clickedUrl
                });
            }
        });
    }

    @Output() edit: EventEmitter<InteractionModel> = new EventEmitter<InteractionModel>();
    @Output() delete: EventEmitter<InteractionModel> = new EventEmitter<InteractionModel>();
    @Output() viewConversation: EventEmitter<void> = new EventEmitter<void>();


    interactionInternal: InteractionModel;
    eventHierarchy: EventViewModel[] = [];

    expanded: boolean = false;
    preferences: PreferencesModel;

    subscriptions: Subscription[] = [];

    readonly interactionType = InteractionType;
    readonly buttonTypes = ButtonTypesEnum;
    readonly topStatLabels = topStatLabels;

    constructor(
        public targetingSearchService: TargetingSearchService,
        public targetingListService: TargetingListService,
        public listPickerService: ListPickerService,
        public localizationService: LocalizationService,
        public coreDialogService: CoreDialogService,
        public targetingRhpContextsService: TargetingRhpContextsService,
        private currentUserStateService: CurrentUserStateService,
        public distributionPickerService: DistributionPickerService,
        @Inject(APP_BASE_HREF) public appBaseHref: string,
    ) {
        super(
            targetingSearchService,
            targetingListService,
            listPickerService,
            localizationService,
            coreDialogService,
            targetingRhpContextsService,
            distributionPickerService
        );
    }


    ngOnInit() {
        this.subscriptions.push(
            this.currentUserStateService.getPreferences().pipe(filter(x => !!x)).subscribe(
                prefs => this.preferences = prefs
            )
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
